import React, { useEffect, useState } from 'react';
import Helpers from '../../helpers/shared.helper';
import Translations from "../../services/translation.service";
import Errors from '../../services/errors.service';
import Flow from '../../services/flow.service';
import Payments from '../../services/payments.service';
import Settings from '../../services/settings.service';
import Storage from "../../services/storage.service";
import SpinnerTimeLoader from "../shared/timeLoading";
import DownloadApps from '../shared/DownloadApps';

const subscriptions = [];
let tap;
let card;
const CommonPaymentTap = props => {
    const [loadingTapjsli, setLoadingTapjsli] = useState(window.Tapjsli ? false : true);
    const [ticking, setTicking] = useState(1);
    const [loadingResult, setLoadingResult] = useState(false);
    const [translationsKeys, setTranslationsKeys] = useState(Translations.keys ? Translations.keys : {});
    const [formValid, setFormValid] = useState(false);
    const [activeLanguage, setActiveLanguage] = useState(Translations.activeLang === "ar" ? "rtl" : "ltr")
    const [forceRender, setForceRender] = useState({});

    useEffect(() => {
        //check for tap library load
        let timerID = null;
        if (window.Tapjsli && !loadingTapjsli) {
            if (timerID) clearInterval(timerID);
            let elements;
            let style;
            let labels;
            let paymentOptions;
            tap = window.Tapjsli(Settings.tap_sdk_key);

            // tap = window.Tapjsli("pk_test_Q2yCpShutgd5UewBxMbl6OP8") testing pk Adham
            //sk_test_Wq2GcVHAJ6OzDtIjxlZau1Sr sk
            elements = tap.elements({});
            style = {
                base: {
                    color: '#404040',
                    fontFamily: 'Poppins',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    fontWeight: 700,
                    lineHeight: 'normal',
                    borderRadius: '10px',
                    border: '1px solid #898D9A',
                    background: 'red',
                    '::placeholder': {
                        color: '#404040',
                        fontSize: '24px',
                        lineHeight: "36px"
                    }
                },
                invalid: {
                    color: '#e10a0a'
                }
            };
            // input labels/placeholders
            labels = {
                cardNumber: Translations.keys["stf_topup_input_card_number_label"],
                expirationDate: Translations.keys["stf_topup_card_expiry_date"],
                cvv: Translations.keys["stf_topup_input_cvc_label"] || "CVV",
                cardHolder: Translations.keys["stf_topup_input_card_holder_label"]
            };
            //payment options
            paymentOptions = {
                currencyCode: Settings.tap_pay_currency,
                // KSA: ["SAR"]
                // KW: ["KWD"]
                labels: labels,
                TextDirection: activeLanguage,
                paymentAllowed: Settings.tap_pay_supported_networks
                // KSA: ["VISA", "MASTERCARD", "MADA"]
                // KW: ['VISA', "MASTERCARD"]
            }
            //create element, pass style and payment options
            card = elements.create('card', { style: style }, paymentOptions);
            //mount element
            card.mount('#element-container');
        } else {
            timerID = setInterval(() => {
                if (window.Tapjsli) {
                    setLoadingTapjsli(false);
                    setTicking(ticking + 1);
                }
            }, 500);
        }

        return () => {
            if (timerID)
                clearInterval(timerID);
        }

    }, [loadingTapjsli, ticking, activeLanguage]);

    const forceUpdate = () => {
        setForceRender({ ...forceRender });
    }
    useEffect(() => {
        forceUpdate();
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        subscriptions.push(
            Translations.getKeysObsrv().subscribe(data => {
                setTranslationsKeys(data);
                setActiveLanguage(Translations.activeLang === "ar" ? "rtl" : "ltr")
            })
        )

        return () => {
            if (subscriptions && subscriptions?.length) {
                for (let subscription of subscriptions) {
                    subscription.unsubscribe();
                }
            }
        }
    }, []);

    const handleError = (code = true) => {
        let type = Errors.getErrorType(code);
        Storage.set("payment_error", type);
        Helpers.debug_payment("going back to payment because of error type: ", type);
        Flow.goTo(Settings.routes["pay"]["path"]);
    };

    const tapTokenHandler = (tapTokenData => {
        Helpers.debug_payment("tapTokenHandler->success token()");
        let exp_year = tapTokenData.card.exp_year > 10 ? tapTokenData.card.exp_year : "0" + tapTokenData.card.exp_year;
        let exp_month = tapTokenData.card.exp_month > 10 ? tapTokenData.card.exp_month : "0" + tapTokenData.card.exp_month;
        let eligabilityData = {
            alias_: tapTokenData.id,
            card_number: tapTokenData.card.first_six + "******" + tapTokenData.card.last_four,
            expiry_date: exp_year + "" + exp_month
        }
        Payments.checkEligabilityKW(eligabilityData)
            .then(response => {
                if (response.status === 201 && response.data && response.data.is_eligibile) {
                    let tapPayload = props.tapPayload;
                    let data = {
                        alias: tapTokenData.id,
                        ...tapPayload?.paymentData
                    };
                    Payments.CommonSaveCard(data, tapPayload?.apiEndpoint)
                        .then(response => {
                            Helpers.debug_payment("save_card response: ", response);
                            if (response && response.data && response.data.Status) {
                                let order_id = {};
                                let status = {};
                                order_id[Storage.get("session")] = response.data.OrderID;
                                status[Storage.get("session")] = response.data.Status;

                                Helpers.debug_payment('order_id', order_id);

                                Storage.set("order_id", JSON.stringify(order_id), true);
                                Storage.set("status", JSON.stringify(status), true);
                                // Storage.set("tap_data", JSON.stringify(tapTokenData), true)

                                if (response.data.HTML_ANSWER) {
                                    Helpers.debug_payment('window.location.href = ', response.data.html);
                                    window.location.href = response.data.HTML_ANSWER;
                                } else {
                                    let tap_data = {}
                                    tap_data[Storage.get("session")] = tapTokenData;
                                    Storage.set("tap_data", JSON.stringify(tap_data), true);
                                    setLoadingResult(false);
                                }

                            } else {
                                setLoadingResult(false);
                                throw new Error("saveCardError");
                            }
                        })
                        .catch(error => {
                            setLoadingResult(false);
                            if (error && error.response && error.response.data && error.response.data.code) {
                                handleError(error.response.data.code);
                            } else {
                                handleError();
                            }
                        });
                } else {
                    setLoadingResult(false);
                    Storage.set("payment_error", true);
                }

            }).catch(error => {
                setLoadingResult(false);
                if (error && error.response && error.response.data && error.response.data.error) {
                    Errors.handleError(error.response.data.error)
                } else {
                    handleError();
                }
            })
    });
    //card change event listener
    if (card) {
        card.addEventListener('change', function (event) {
            if (event.loaded) {
                setLoadingResult(false);
            }
            let displayError = document.getElementById('error-handler');
            if (event.error) {
                displayError.textContent = event.error.message;
            } else {
                displayError.textContent = '';
            }
            if (event.status) {
                if (event.status === "invalid") {
                    setFormValid(false);
                } else {
                    setFormValid(true)
                }
            }
        });
    }

    const submitForm = (event) => {
        event.preventDefault();
        setLoadingResult(true);

        tap.createToken(card).then(function (result) {
            if (result.error) {
                // Inform the user if there was an error
                var errorElement = document.getElementById('error-handler');
                errorElement.textContent = result.error.message;
                setLoadingResult(false);
            } else {
                // Send the token to server
                tapTokenHandler(result)
            }
        });
    };

    return (
        <>
            <div className='w-100 payment-container'>
                {!loadingTapjsli &&
                    <div >
                        <form id="form-container" method="post" action="/charge" onSubmit={event => submitForm(event)}>
                            {/* <!-- Tap element will be here --> */}
                            <div id="element-container" style={{ overflow: "auto" }}></div>
                            <div id="error-handler" role="alert"></div>
                            <div id="success" style={{ display: "none", position: "relative", float: "left" }}>
                                Success! Your token is <span id="token"></span>
                            </div>
                            {/* <!-- Tap pay button --> */}
                            {loadingResult ? <div className="translation-loading-spinner">
                                <SpinnerTimeLoader />
                            </div> : <>
                                <div className="common-payment-button-container">
                                    <button
                                        id="tap-btn"
                                        className={`common-button`}
                                        disabled={!formValid}
                                    >
                                        {translationsKeys["scr_3.6_A_action_btn"]}
                                    </button>
                                </div></>}
                        </form>
                    </div>
                }
            </div>
            <DownloadApps
                info={translationsKeys["scr_3.3.3_app_download_info"]}
                classes={"download-apps"}
                google_play_link={Settings.google_play_link}
                app_store_link={Settings.app_store_link}
                huawei_store_link={Settings.huawei_store_link}
            />
        </>
    )
}

export default CommonPaymentTap;
